import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, ValidationErrors, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import { MiniTracker, AddTrackable, UpdateTrackable, GetMiniTrackers } from 'huddyapi';



@Component({
  selector: 'edit-treatment-dialog',
  templateUrl: 'edit-treatment-dialog.component.html',
  styleUrls: ["./edit-treatment-dialog.component.scss"]
})
export class EditTreatmentDialog  {
  

  edited : MinimalTrackable;


  treatmentForm = this.formBuilder.group({
    name: ['', [Validators.required]],
    description:  ['', [Validators.required]]
});

  constructor(
    public dialogRef: MatDialogRef<EditTreatmentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: TreatmentDialogInput,
    private formBuilder : UntypedFormBuilder,
    public store : Store
  )
  {
    this.treatmentForm.setValue({
      name: data.current.name ?? '',
      description: data.current.description ?? ''
    });
    this.edited = {
      id : data.current.id,
      name: data.current.name ?? '', 
      status: data.current.status ?? 'ACTIVE',
      description: data.current.description ?? '',
      username: data.current.username ?? '',
      trackableType: 'TREATMENT'
    };



    console.log('edited=', this.edited);


  }

  ngOnInit(): void {
   console.log(this.edited);
  }

  isFormInValid() {
    if (this.treatmentForm.invalid) {
      return true;
    }
    let matching : MinimalTrackable[] = this.data.existing.filter(t => 
      t.id != this.edited.id && t.name === this.treatmentForm.value.name
    )
    return matching.length > 0;
  }

  onSubmitForm(treatmentForm) {
   this.save();
  }

  close() {
     
      this.dialogRef.close();
  }

  save() {
    this.edited.name = this.treatmentForm.value.name;
    this.edited.description = this.treatmentForm.value.description;
    if (this.edited.id) {
      this.store.dispatch(new UpdateTrackable(this.edited)).subscribe(t => {
        this.store.dispatch(new GetMiniTrackers(false, this.edited.username));
        this.close();
      });
    } else {
      this.store.dispatch(new AddTrackable(this.edited)).subscribe(t => {
        this.store.dispatch(new GetMiniTrackers(false, this.edited.username));
        this.close();
      });
    }
  }

}

export interface MinimalTrackable {
  id : number;
  name: string;
  status: string;
  description: string;
  username: string;
  trackableType: string;
}

export interface TreatmentDialogInput {
  existing : MinimalTrackable[];
  current : MinimalTrackable;
}